<div class="app-container" id="app" (scroll)="handleScroll($event)">
  <div class="main-content">
    <main [@routerTransition]="getState(o)">
      <router-outlet #o="outlet" (activate)="onActivate()"></router-outlet>
    </main>
  </div>
</div>
